// Wapper methods on OrganisationEntity.tsx

import { BusinessEntity, OrganisationEntity } from "Models/Entities";
import { LocaleCompareAttrAsc } from "Util/StringUtils";
import { ComboboxOption } from "Views/Components/Combobox/Combobox";

/**
 * Gets the list of selectable business entities as combo box options
 */
function getBusinessOptions(organisation?: OrganisationEntity, filterForMonitor?: boolean): ComboboxOption<string>[] {

	if (!organisation) return [];

	return organisation.businessEntitys
		.filter(BusinessEntity.IsLinkedToUser)
		.filter(x => filterForMonitor == null ? true : x.enabledForMonitor == filterForMonitor)
		.sort(LocaleCompareAttrAsc('name'))
		.map(business => {
			return {
				display: business.name,
				value: business.id,
			};
		})
}

// Wrapper methods for organisation entity
export const OrganisationHelper = {
	getBusinessOptions: getBusinessOptions
}
